export default __webpack_public_path__ + "static/media/favicon.6f87c358.ico";